import { useCallback } from "react";
import { executeAction } from "../store/actions";
import { useChatServerDispatch } from "../utils/useChatServerDispatch";

export type ExecuteActionCallback = (
    text: string,
    meta?: { token?: string; action?: string; ui?: string }
) => void;

export function useExecuteActionCallback(): ExecuteActionCallback {
    const dispatch = useChatServerDispatch();

    return useCallback<ExecuteActionCallback>(
        (text, meta) => {
            dispatch(executeAction(text, meta));
        },
        [dispatch]
    );
}
